import { useTranslation } from 'react-i18next';
import { isNull } from 'lodash';
import { Image } from '@root/types';
import s from './ClientInformation.module.less';

type Props = {
  name: string | null;
  image: Image | null;
};

export default function Description({ name, image }: Props) {
  const { t } = useTranslation('tourbook');
  if (isNull(name) && isNull(image)) return null;

  return (
    <div className={s.clientInformation}>
      <div className={s.clientLabel}>{t('header.clientLabel', { name })}</div>
      {image && <img className={s.clientLogo} src={image.smallPath} alt="Client logo" />}
    </div>
  );
}
